import { render, staticRenderFns } from "./FeaturedArticle.vue?vue&type=template&id=41c5b064&scoped=true&"
import script from "./FeaturedArticle.vue?vue&type=script&lang=ts&"
export * from "./FeaturedArticle.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedArticle.vue?vue&type=style&index=0&id=41c5b064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5b064",
  null
  
)

export default component.exports